<template>
  <div>
    <button @click="showAll = !showAll" class="btn-sm btn-info btn">
      ყველას ჩვენება
    </button>
    <div v-if="showAll">
      <h6 v-if="allquizrooms.length">ყველა ქვიზრუმი</h6>
      <ol v-if="allquizrooms.length">
        <li v-for="room in allquizrooms" :key="room.id">
          <a :href="room.path">{{ room.created_at }}</a>
        </li>
      </ol>
    </div>
    <p v-if="lastroom != 'null'">
      შენს მიერ შექმნილი ბოლო ქვიზრუმი
      <a :href="lastroom">{{ lastroom }}</a>
    </p>
    <form @submit.prevent="add" v-if="!roomlink">
      <div class="form-group my-3">
        <v-select
          :reduce="(item) => item.id"
          label="name"
          :options="tests"
          v-model="test_id"
        ></v-select>
      </div>
      <div class="form-group text-right my-3">
        <button type="submit" class="btn">შექმნა</button>
      </div>
    </form>
    <div v-else>
      თქვენი ქვიზრუმი შექმნილია:
      <a :href="roomlink">{{ roomlink }}</a>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
export default {
  props: ["tests", "lastroom", "allquizrooms"],
  components: { "v-select": vSelect },
  data() {
    return {
      showAll: false,
      rooms: [],
      test_id: "",
      roomlink: null,
    };
  },
  methods: {
    add() {
      axios
        .post("/quizroom", { test_id: this.test_id })
        .then((res) => (this.roomlink = res.data.link));
    },
  },
};
</script>
